import React from 'react'
import CustomTop from './CustomTop'
import { Navbar } from '../Components'

const ChildSafetyPolicy = () => {
    return (
        <>
            <CustomTop />
            <div className='main-container'>
                <Navbar />
                <div className="container privacy-policy">
                    <h1 style={{ textAlign: 'center' }}>Safety Standards: Protection Against Child Sexual Abuse and Exploitation (CSAE)</h1>
                    <p><strong>Effective Date:</strong> 10th August 2024</p>
                    <p>
                        At<b>Hyderabad Casting Club World</b>, we are committed to providing a <b>safe and secure</b> platform for all users. We have <b>zero tolerance</b> for <b>child sexual abuse and exploitation (CSAE)</b> and implement strict measures to detect, prevent, and report any violations.
                    </p>
                    <h3>1. Prohibited Content & Activities</h3>
                    <p>The following activities and content are strictly prohibited on our platform:</p>
                    <div class="content-section prohibited">
                        <p>🚫 <strong>Child Exploitation Content:</strong> Any content, images, videos, or messages that involve or promote child sexual abuse, exploitation, or grooming.</p>
                        <p>🚫 <strong>Sexualization of Minors:</strong> Any content that depicts, describes, or promotes the sexualization of individuals under 18.</p>
                        <p>🚫 <strong>Grooming & Inappropriate Contact:</strong> Any attempts to befriend or manipulate minors for exploitative purposes.</p>
                        <p>🚫 <strong>Solicitation & Trafficking:</strong> Any form of solicitation, recruitment, or trafficking of minors for exploitative purposes.</p>
                    </div>
                    <h3>2. Preventative Measures</h3>
                    <div class="content-section preventative">
                        <p>✅ <strong>Strict Age Policy:</strong> Only users 18 years and above are allowed to register.</p>
                        <p>✅ <strong>AI & Human Moderation:</strong> User-generated content, including profiles, images, and videos, undergo moderation.</p>
                        <p>✅ <strong>Reporting System:</strong> Users can report any inappropriate content or behavior, which will be reviewed immediately.</p>
                        <p>✅ <strong>Account Verification:</strong> Profile verification measures help prevent impersonation and misuse.</p>
                    </div>

                    <h3>3. Reporting & Compliance</h3>
                    <div class="content-section reporting">
                        <p>We actively <b>cooperate with law enforcement</b> and <b>child protection agencies</b> to take action against CSAE-related violations.</p>
                        <p><strong>📢 How to Report:</strong></p>
                        <p>If you come across any content or behavior related to CSAE on our platform:</p>
                        <ul>
                            <li><b>Use the "Report" button</b> on the app</li>
                            <li><b>Email us at</b>: <a href="mailto:info@hyderabadcastingclub.com">info@hyderabadcastingclub.com</a></li>
                            <li><b>Contact law enforcement</b> if necessary</li>
                        </ul>
                        <p><strong>⚖️ Legal Compliance:</strong> We comply with global standards, including:</p>
                        <ul>
                            <li><b>Indian IT Act, 2000</b> (Section 67B)</li>
                            <li><b>Protection of Children from Sexual Offenses (POCSO) Act, 2012</b></li>
                            <li><b>International CSAE reporting protocols</b></li>
                        </ul>
                    </div>

                    <h3>4. Enforcement & Penalties</h3>
                    <div class="content-section enforcement">
                        <p>🔴 <strong>Immediate Account Termination:</strong> Users violating CSAE policies will have their accounts permanently banned.</p>
                        <p>🔴 <strong>Legal Action:</strong> We reserve the right to report CSAE offenders to law enforcement authorities.</p>
                        <p>🔴 <strong>Content Removal:</strong> Any CSAE-related content is immediately removed and flagged for investigation.</p>
                    </div>

                    <h2>Our Commitment</h2>
                    <p>We are dedicated to maintaining a safe digital space for entertainment professionals. We take proactive measures to prevent, detect, and report CSAE while fostering a secure and professional environment.</p>

                    <div class="content-section contact">
                        <p>📩 <strong>For concerns or reports, contact:</strong> <a href="mailto:info@hyderabadcastingclub.com">info@hyderabadcastingclub.com</a></p>
                    </div>
                </div>
            </div>
        </>
    )
}

export { ChildSafetyPolicy }
